import Matter from "matter-js";
import { AudioManager, ITrack } from "../../AudioManager";
import { ISystemContext } from "../../Context/SystemContext";
import { LogGroup, Size, Scale, SetStyles, AddMouseDownListener, Log, Safe } from "../../MyHelpers";
import { MyVideo } from "../../MyVideo";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { VideoResource2 } from "../../ResourceManager/VideoResource";
import { Presentation, Settings } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { ITransition } from "./ITransition";
import { ITransitionParams } from "./ITransitionFactory";
import { PixiSprite } from "../Sprite/PixiSprite";
import * as PIXI from 'pixi.js'
import { RegisterPixi, UnregisterPixi } from "../../PixiDebug";
import { IInterval } from "../../Context/Interval";
import { TweenMax } from "gsap";
import * as matterwrap from "matter-wrap"
import { FrontendErrorCode } from "../../api";
import { service } from "../../services";




Matter.use('matter-wrap');
// or
Matter.use(matterwrap);


interface objectScene {
    animatedSprite: PIXI.AnimatedSprite,
    particle: Matter.Body,    
}


export class VideoSpriteTransitionParticlesPIXiMatterJS implements ITransition {

    protected systemContext: ISystemContext = null;
    protected params: ITransitionParams = null;

    protected view: HTMLElement = null;
    protected audio: AudioManager = null;
    protected resid: ResourceIdentifier = null;
    protected logGroup: LogGroup = null;
    protected gameName: string = null;
    protected TitleSpriteTransition: CanvasSprite = null;
    protected spriteResource: SpriteResource;
    protected videoResource: VideoResource2;
    protected track: ITrack;
    protected nameResource: string;
    protected fadeOut: boolean;
    protected particleSpriteResource: PixiSprite;
    protected restoreWebGlInterval: IInterval = null;
    protected sceneObjectsTransition: objectScene[] = [];

    public onTransitionStart: () => void = null;
    public onTransitionEnd: () => void = null;

    protected engine: Matter.Engine = null;
    protected render: Matter.Render = null;
    //always by defaut needs disable because use more performance for use 2 canvas at same time 
    protected debugerMatter: boolean = false;
    protected debugerMatterBackgroundColor: string = "rgba(0, 0, 0, 0.5)";
    protected viewMatterPIXICanvasSize = new Size(Scale.W(1280), Scale.H(720 * Settings.Screens));
    //protected particleLeftInterfal: IInterval = null
    protected particlesTransitionSpawn: IInterval = null;
    protected startTimeoutFideOut : IInterval = null;

    protected app: PIXI.Container = null;
    protected totalParticles : number = 200;

    public constructor(params: ITransitionParams) {
        this.params = params;
        this.resid = params.resid;
        this.audio = params.audio;
        this.logGroup = params.logGroup
        this.gameName = params.gameName;
        this.systemContext = params.systemContext;
        this.spriteResource = params.spriteResource;
        this.track = params.soundResource;
        this.videoResource = params.videoResource;
        this.nameResource = params.nameResource;
        this.fadeOut = params.fadeOut;
        this.particleSpriteResource = params.particlesSprite;

        // params.boundingBox.boundingbox.forEach((value, index) => {
        //     if (index % 2 === 0) {
        //         this.particleBoundingBox.push(new PIXI.Point(
        //            params.boundingBox.boundingbox[index] * Scale.X(1),  
        //             params.boundingBox.boundingbox[index + 1] * Scale.Y(1)
        //         ));
        //     }
        // });

        this.view = document.createElement("div");
        this.view.classList.add(this.resid.Scope());
        this.view.classList.add(this.gameName + "TransitionParticles");
        this.view.style.zIndex = ZIndex.BonusTransition + "";
        this.view.style.position = "absolute";
        this.view.style.height = (Settings.ScreenHeight * Settings.Screens) + "px"; 
        this.view.style.width = Settings.ScreenWidth + "px"; 
        this.view.style.bottom = Scale.Ypx(0);
        this.view.style.display = "none";
        


        this.restoreWebGlInterval = params.systemContext.TimingContext().CreateInterval("restoreWebGlIntervalFillingPot", 500, () => {
            let success = this.tryRecoverWebglContext();

            // success, stop timer
            if (!success) {
                this.recoverFailCount++;
                if (this.recoverFailCount == this.maxRecoverFailCount) {
                       void service.api.frontendError(FrontendErrorCode.WebGLRecoverFail, `${this.resid.ID()} in ${this.recoverFailCount} tries`);
                }
            }
            success = null;
        });

        let countSpawnParticleLeft : number = 0;
        let conuntSpawnParticleRight : number = 0;

        //this.particleLeftInterfal = this.params.systemContext.TimingContext().CreateTimeout("createParticleLeft", 50, () => {
            // //if (countSpawnParticleLeft < this.totalParticles) {
            //     for (let particleNewIndex = 0; particleNewIndex <=this.totalParticles; particleNewIndex++) {
            //         Matter.Vertices.centre(this.particleBoundingBox);
            //         let matterCoinPolygonLeft = Matter.Bodies.fromVertices(Matter.Common.random(0, this.viewMatterPIXICanvasSize.width), (Settings.ScreenHeight * Settings.Screens) - (Matter.Common.random(0, Settings.ScreenHeight * Settings.Screens)), Matter.Vertices.hull(this.particleBoundingBox) as any[], {
            //             density: 1,
            //             //friction: 1,
            //             //frictionStatic: 1,
            //             //isStatic: true, 
            //             collisionFilter: {
            //                 category: 0x0000, // Puedes ajustar este valor según tus necesidades
            //                 mask: 0x0000
            //             }
            //         });

            //         matterCoinPolygonLeft.plugin.wrap = {
            //             min: { x: 0, y: -100 },
            //             max: { x: Settings.ScreenWidth, y: Settings.ScreenWidth * Settings.Screens }
            //         };

            //         Matter.Composite.add(this.engine.world, [matterCoinPolygonLeft]);
            //         //Matter.Body.applyForce(matterCoinPolygonLeft, matterCoinPolygonLeft.position, { x: 1, y: 0 });  
            //         Matter.Body.setVelocity(matterCoinPolygonLeft, { x: 0, y: Matter.Common.random(0, 100) });


            //         // Pixi Sprite        
            //         let imageSpriteLeft = new PIXI.AnimatedSprite(this.particleTexture);
            //         imageSpriteLeft.anchor.set(0.5, 0.5);
            //         imageSpriteLeft.position = matterCoinPolygonLeft.position;
            //         imageSpriteLeft.rotation = matterCoinPolygonLeft.angle;
            //         imageSpriteLeft.zIndex = this.categoryParticleLeft;
            //         //imageSpriteLeft.scale.set(Scale.W(1),Scale.H(1));
            //         this.app.stage.addChild(imageSpriteLeft);

            //         // Add the complete scene object (body and sprite) to our array of objects. We'll track those objects in the pixi frame updates (see app.ticker below).
            //         this.sceneObjectsTransition.push({
            //             particle: matterCoinPolygonLeft,
            //             animatedSprite: imageSpriteLeft,
            //         });
            //         countSpawnParticleLeft++
            //     }
            // //} else {
            //     //this.particleLeftInterfal.Stop();
            //     //countSpawnParticleLeft = 0;
            // //}
        //});

      
        // this.particlesTransitionSpawn = this.params.systemContext.TimingContext().CreateTimeout("createParticleLeft", 50, () => {
        //     // let circlePhysicsRadius : number = Scale.W(300/2);
        //     // let offsetXPosition : number = 1.20;
        //     // let offsetYPosition : number = 1.20;
        //     // //if (conuntSpawnParticleRight < this.totalParticles) {
        //     //     var stack = Matter.Composites.stack( (circlePhysicsRadius / 2) * offsetXPosition ,(circlePhysicsRadius / 2) * offsetYPosition , Math.round(this.viewMatterPIXICanvasSize.width / circlePhysicsRadius), Math.round((this.viewMatterPIXICanvasSize.height * Settings.Screens) / circlePhysicsRadius), circlePhysicsRadius * offsetXPosition, circlePhysicsRadius * offsetYPosition, (x, y)=> {
        //     //         // let matterCoinPolygonLeft = Matter.Bodies.fromVertices(x, y,Matter.Vertices.hull(this.particleBoundingBox) as any[], {
        //     //         //     //density: 1,
        //     //         //     //friction: 1,
        //     //         //     //frictionStatic: 1,
        //     //         //     //isStatic: true, 
        //     //         //     collisionFilter: {
        //     //         //         category: 0x0000, 
        //     //         //         mask: 0x0000
        //     //         //     }
        //     //         // });

        //     //         let circle = Matter.Bodies.circle(x, y, 1, {
        //     //             collisionFilter: {
        //     //                 category: 0x0000, 
        //     //                 mask: 0x0000
        //     //             }
        //     //         })

        //     //         circle.plugin.wrap = {
        //     //             min: { x: circlePhysicsRadius * -1, y:  circlePhysicsRadius * -1  },
        //     //             max: { x: this.viewMatterPIXICanvasSize.width , y: (this.viewMatterPIXICanvasSize.height * Settings.Screens) + (circlePhysicsRadius)}
        //     //         };

                    
        //     //         // Pixi Sprite        
        //     //         let imageSpriteLeft = new PIXI.AnimatedSprite(this.particleTexture);
        //     //         imageSpriteLeft.anchor.set(0.5, 0.5);
        //     //         imageSpriteLeft.position = circle.position;
        //     //         imageSpriteLeft.rotation = circle.angle;
        //     //         imageSpriteLeft.zIndex = this.categoryParticleLeft;
        //     //         imageSpriteLeft.scale.set(1.25,1.25);
        //     //         this.app.stage.addChild(imageSpriteLeft);

        //     //         // Add the complete scene object (body and sprite) to our array of objects. We'll track those objects in the pixi frame updates (see app.ticker below).
        //     //         // this.sceneObjectsTransition.push({
        //     //         //     particle: circle,
        //     //         //     animatedSprite: imageSpriteLeft,
        //     //         // });

        //     //         //Matter.Composite.add(this.engine.world, [matterCoinPolygonLeft]);
        //     //         //Matter.Body.applyForce(matterCoinPolygonLeft, matterCoinPolygonLeft.position, { x: 1, y: 0 });  
        //     //         //Matter.Body.setVelocity(matterCoinPolygonLeft, { x: 0, y: Matter.Common.random(0, 100) });
        //     //         return circle
                    
        //     //     });

                
        //     //     Matter.Composite.add(this.engine.world, [stack]);
                
        //     // // } else {
        //     // //     this.particleRightInterfal.Stop();
        //     // //     conuntSpawnParticleRight = 0;
        //     // // }
        //     // circlePhysicsRadius = null;
        //     // offsetXPosition = null;
        //     // offsetYPosition = null;
        // });

        this.startTimeoutFideOut = this.params.systemContext.TimingContext().CreateTimeout("createParticleLeft", 3500, () => {
            TweenMax.to(this.view, 2, {
                autoAlpha: 0, display: "none",
                onStart: () => {
                    this.OnTransitionEnded();
                }, onComplete: () => {
                    this.updateMatter = false;
                    this.sceneObjectsTransition.forEach(obj => {
                        //Matter.Composite.remove(this.engine.world, obj.particle);
                        obj.animatedSprite.removeFromParent();
                        obj.particle = null;
                        obj.animatedSprite = null;
                    });
                    this.sceneObjectsTransition = [];
                    Matter.World.clear(this.engine.world, true);
                    this.TitleSpriteTransition.View().style.display = "none";
                    //setTimeout(() => {
                        this.DestroyTransitionPixi();
                    //}, 500);
                }
            });
        });
    }
    OnResize(): void {
        throw new Error("Method not implemented.");
    }
    public CreateTransitionPixi (app: PIXI.Container){
        this.app = app;
        this.Create();
    };
    public DestroyTransitionPixi () {
        this.Destroy()
    };


    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {

        //this.PrepareTitleTransition(resourceManager);
        //this.PrepareVideoTransition(resourceManager);
    };
    protected particleTexture  = [];
    protected particleBoundingBox = [];
    protected textureSize : Size = new Size ( 0 , 0 );
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        let sprite: PixiSprite = this.particleSpriteResource;
        let Textures: PIXI.Texture[] = [];
        //let boundingBoxScaledWidth = Scale.W(this.params.boundingBox.imgwidth);
        //let needScalingTexture = Math.abs(sprite.DecodedFrames[0].width - boundingBoxScaledWidth) > 3;

        for (let decodedFrames of sprite.DecodedFrames) {

            let symbolTexture = PIXI.Texture.from(decodedFrames);
            this.textureSize.Width = symbolTexture.width;
            this.textureSize.Height = symbolTexture.height;
            Textures.push(symbolTexture);
        }

        
        for (let value of Textures.values()) {
            //console.log(value);
            this.particleTexture.push(value);
            value = null;
        }

        this.LoadTitleTransition(resourceManager);
       //this.Create();
    };

    public LoadTitleTransition(resourceManager: IReadOnlyResourceManager) : void {

        this.TitleSpriteTransition = new CanvasSprite({sprite: this.spriteResource.sprite.Copy(), canvasSize: new Size(Scale.W(1920), Scale.H(1080))});
        this.TitleSpriteTransition.View().style.position = "absolute";
        
        if( Settings.Screens == 1 )
        {
            this.TitleSpriteTransition.View().style.position = "relative";
        }
        this.TitleSpriteTransition.View().style.display = "none";
        this.TitleSpriteTransition.View().style.bottom = Scale.Ypx(0);
        // if (Settings.PresentationType != Presentation.VideoParticleTransition) {
        //     this.TitleSpriteTransition.View().style.top = (Scale.H(Settings.Screens - 1) * Settings.ScreenHeight ) + "px";
        // }
        //this.TitleSpriteTransition.View().style.left="60px";
        this.TitleSpriteTransition.View().style.zIndex = ZIndex.BonusTransitionTitle.toString();
        //this.TitleSpriteTransition.View().style.display="none";
        this.TitleSpriteTransition.View().classList.add("TitleTransition-StickySpin");
        //this.TitleSpriteTransition.AddOnStartCallback(() => { this.audio.Play(this.resid.ScopedResourceName("transitionLight")); })
        this.TitleSpriteTransition.AddOnStartCallback(() => { this.track.Play(); })
        this.view.appendChild(this.TitleSpriteTransition.View());
    }  

    protected created: boolean = false;
    /** use for create App Pixi.js*/
    public Create() {
        this.created = true;
        try {
            this.InternalCreate();
        }
        catch (ex) {
            this.restoreWebGlInterval.Start();
        }
    }
    /** use for create pixi and registred for dont create multi times */
    public InternalCreate() {
        if (!this.created)
		{
			Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
			return;
		}


        // // Log.Debug(this.logGroup, `Create(): creating reels`);
        // this.app = new PIXI.Application({
        //     width: this.viewMatterPIXICanvasSize.width,
        //     height: this.viewMatterPIXICanvasSize.height,
        //     backgroundAlpha: 0,
        //     // backgroundColor : 0x0A0A0A,
            
        // });
        // //this.app.stage.scale.set(1.5,1.5);
        // //this.app.view.style.scale = "1.5";
        // this.app.stage.name = "PIXIContainer";
        // //this.app.view.style.position = "absolute";
        // this.app.stage.accessibleChildren = true;
        // this.app.stage.accessible = true
        // this.app.stage.sortableChildren = true;
        // this.app.view.style.bottom = Scale.ZERO_PX;
        // this.app.view.style.zIndex = ZIndex.BonusTransition + "";



        // RegisterPixi(this.app, this.resid);
        // this.app.view.addEventListener("webglcontextlost", this.webglcontextlostInstance);
        // this.app.stop(); // use custom ticker
        // this.view.appendChild(this.app.view);

        //globalThis.__PIXI_APP__ = this.app;
        this.createEngine();
        //this.updateMatter = true;
        this.CreateParticlesSprites();
    }

    protected webglcontextlost() {
        console.log(this.resid.ID() + " context lost");
        // try recover right now, or start timer to try recover later
        let success = this.tryRecoverWebglContext();
        if (success) {
            // all good
            return;
        }

        // error recovering, start timer
        this.restoreWebGlInterval.Start();
    }

    protected recoverCount: number = 0;
    protected recoverFailCount: number = 0;
    protected readonly maxRecoverFailCount = 5;
    protected tryRecoverWebglContext(): boolean {
        if (!this.created) {
            this.restoreWebGlInterval.Stop();
            this.recoverFailCount = 0;

            // app not created, don't care
            return true;
        }

        console.log(this.resid.ID() + " trying to recover");
           void service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
        try {
               void service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
            this.InternalDestroy();
               void service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);
        }
        catch (ex) {
               void service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
        }

        try {
            // Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
               void service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
            this.InternalCreate();

            // all fine, stop timer
            this.restoreWebGlInterval.Stop();
            console.log(this.resid.ID() + " recover success");

            this.recoverCount++;
            this.restoreWebGlInterval.Stop();
            this.recoverFailCount = 0;

               void service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
               void service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

            return true;
        }
        catch (ex) {
               void service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

            console.log(this.resid.ID() + " error recovering", ex);

            // prevent spamming the backend
            if (this.recoverFailCount < this.maxRecoverFailCount) {


                if (ex.message.toLowerCase().includes("this browser does not support webgl")) {
                       void service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
                else {
                       void service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
            }
        }

        return false;
    };


    protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);

    /** use for destroy  App Pixi.js if that exist*/
    public Destroy() {        
        this.InternalDestroy();
        this.created = false;
        this.restoreWebGlInterval.Stop();
    }

    public InternalDestroy()
    {
        this.updateMatter = false;
        if (!this.created) {
            Log.Debug(this.logGroup, `Destroy() FillingPot: no app, not destroying anything`);
            return;
        }
        //this.SaveCurrentIncrement();
        
        
        //this.spineHit = null;

        Matter.World.clear(this.engine.world, true);
        Matter.Engine.clear(this.engine);
        
     
        //this.OnDestroyCallback?.();        
    }

    protected createEngine() {
        // create an engine
        this.engine = Matter.Engine.create({
            constraintIterations : 0,
            positionIterations:0,
            gravity : {
                //y : Scale.Y(2)
            } 
        });

        //this.engine.gravity.y = 1;

        // // create a renderer
        if (this.debugerMatter == true) {
            this.render = Matter.Render.create({
                element: this.view,
                //element: document.body,
                engine: this.engine,
                options: {
                    width: this.viewMatterPIXICanvasSize.Width,
                    height: this.viewMatterPIXICanvasSize.Height,
                    wireframes: false,
                    showDebug: true,
                    //showAngleIndicator: true,
                    //showPositions: true,
                    //showCollisions: true,                
                    wireframeBackground: this.debugerMatterBackgroundColor,
                    background: this.debugerMatterBackgroundColor,
                }
            });
            this.render.canvas.style.position = "absolute";
            //this.render.canvas.style.bottom = (Scale.H(1080) * -1) + "px";


            //create mouse control for test it 
            // add mouse control
            var mouse = Matter.Mouse.create(this.view),
                mouseConstraint = Matter.MouseConstraint.create(this.engine, {
                    mouse: mouse,
                    constraint: {
                        stiffness: 0.2,
                        render: {
                            visible: true
                        }
                    }
                });

            this.render.mouse = mouse

            Matter.Composite.add(this.engine.world, mouseConstraint);
            // keep the mouse in sync with rendering
            //this.render.mouse = mouse;
        }
        if (this.render != null) {
            AddMouseDownListener(this.render.canvas as HTMLCanvasElement, () => {

            });
        } else {
            AddMouseDownListener(this.view as HTMLCanvasElement, () => {

            });
        }       
    }

    protected CreateParticlesSprites() {
        if (this.app == null) return
        let circlePhysicsRadius: number = Scale.W(300 / 2);
        let offsetXPosition: number = 1.20;
        let offsetYPosition: number = 1.20;
        //if (conuntSpawnParticleRight < this.totalParticles) {
        var stack = Matter.Composites.stack((circlePhysicsRadius / 2) * offsetXPosition, (circlePhysicsRadius / 2) * offsetYPosition, Math.round(this.viewMatterPIXICanvasSize.Width / circlePhysicsRadius), Math.round((this.viewMatterPIXICanvasSize.Height * Settings.Screens) / circlePhysicsRadius), circlePhysicsRadius * offsetXPosition, circlePhysicsRadius * offsetYPosition, (x, y) => {
            // let matterCoinPolygonLeft = Matter.Bodies.fromVertices(x, y,Matter.Vertices.hull(this.particleBoundingBox) as any[], {
            //     //density: 1,
            //     //friction: 1,
            //     //frictionStatic: 1,
            //     //isStatic: true, 
            //     collisionFilter: {
            //         category: 0x0000, 
            //         mask: 0x0000
            //     }
            // });

            let circle = Matter.Bodies.circle(x, y, 1, {
                collisionFilter: {
                    category: 0x0000,
                    mask: 0x0000
                }
            })

            circle.plugin.wrap = {
                min: { x: circlePhysicsRadius * -1, y: circlePhysicsRadius * -1 },
                max: { x: this.viewMatterPIXICanvasSize.Width, y: (this.viewMatterPIXICanvasSize.Height * Settings.Screens) + (circlePhysicsRadius) }
            };


            // Pixi Sprite        
            let imageSpriteLeft = new PIXI.AnimatedSprite(this.particleTexture);
            imageSpriteLeft.anchor.set(0.5, 0.5);
            imageSpriteLeft.position = circle.position;
            imageSpriteLeft.rotation = circle.angle;
            imageSpriteLeft.zIndex = this.categoryParticleLeft;
            imageSpriteLeft.scale.set(1.25, 1.25);
            this.app?.addChild(imageSpriteLeft);

            // Add the complete scene object (body and sprite) to our array of objects. We'll track those objects in the pixi frame updates (see app.ticker below).
            this.sceneObjectsTransition.push({
                particle: circle,
                animatedSprite: imageSpriteLeft,
            });

            //Matter.Composite.add(this.engine.world, [matterCoinPolygonLeft]);
            //Matter.Body.applyForce(matterCoinPolygonLeft, matterCoinPolygonLeft.position, { x: 1, y: 0 });  
            //Matter.Body.setVelocity(matterCoinPolygonLeft, { x: 0, y: Matter.Common.random(0, 100) });
            return circle

        });

        if (stack != null) Matter.Composite.add(this.engine?.world, [stack]);

        // } else {
        //     this.particleRightInterfal.Stop();
        //     conuntSpawnParticleRight = 0;
        // }
        circlePhysicsRadius = null;
        offsetXPosition = null;
        offsetYPosition = null;
    }

    protected started: boolean = false;
    protected categoryWorld : number = 1;
    protected categoryParticleLeft : number = 2;
    protected categoryParticleRight : number = 3;
    public ShowTransiton(): void {     
        if (this.started == false) {     
            
            //this.CreateTransitionPixi();  
            this.updateMatter = true;   
            this.OnTransitionStarted();
            TweenMax.to(this.view, 0.8, {
                autoAlpha: 1, display: "flex"
            });
            
            this.started = true;           
            //this.particleLeftInterfal.Start();
           
            this.fadeSettings();
        }
    };

    protected fadeSettings() {
        
        if (this.fadeOut == true){         
            //FADE OUT VIDEO 
            // setTimeout(() =>
            //     TweenMax.to(this.view, 2, {
            //         autoAlpha: 0, display: "none",
            //         onStart: () => {
            //             this.OnTransitionEnded();
            //         }, onComplete: () => {
            //             this.updateMatter = false;
            //             this.sceneObjectsTransition.forEach(obj => {
            //                 Matter.Composite.remove(this.engine.world, obj.particle);
            //                 obj.animatedSprite.removeFromParent();
            //                 obj.particle = null;
            //                 obj.animatedSprite = null;
            //             })
            //             this.sceneObjectsTransition = [];
            //             setTimeout(() => {
            //                 this.DestroyTransitionPixi();
            //             }, 3000)
            //         }
            //     }
            //     ), 3500);

            this.startTimeoutFideOut.Start();            
            this.TitleSpriteTransition.View().style.display = "block";
            this.TitleSpriteTransition.Start(false);
            //setTimeout(() =>
            // TweenMax.to(this.TitleSpriteTransition.View(), 2,
            //     {
            //         autoAlpha: 1, display: "block", onStart: () => {

            //         }, onComplete: () => {
            //             this.TitleSpriteTransition.Start(false);

            //         }
            //     },
            // )
        }
        else 
        {
            // // ITS DISABLE FADE OUT IN VIDEOs
            // //FADE IN AND FADE OUT TITLE ANIM ENABLED
            // setTimeout(() =>
            // TweenMax.to(this.TitleSpriteTransition.View(), 2,
            //     { autoAlpha: 1 , display : "block", onComplete :() =>{
            //         this.TitleSpriteTransition.Start(false);
            //         TweenMax.to(this.TitleSpriteTransition.View(), 1.5, {
            //             autoAlpha: 0 , delay : 2.5 , display : "none"
            //         })
            //     }
            //     },
            // ), 500);
        }        
        
    }   

    public View(): HTMLElement {
        return this.view
    };

    public OnTransitionStarted() {
        Log.Debug(this.logGroup, "Transition started");
        this.onTransitionStart?.();
    }

    public OnTransitionEnded(): void {
        Log.Debug(this.logGroup, "Transition ended");
        this.started = false;
        this.onTransitionEnd?.();
    }

    protected updateMatter: boolean = false;
    public Update(): void {
        if (this.sceneObjectsTransition.length > 0 && this.updateMatter == true) {

            this.sceneObjectsTransition.forEach((object) => {

                // Make all pixi sprites follow the position and rotation of their body.
                object.animatedSprite.position = object.particle.position;
                object.animatedSprite.rotation = object.particle.angle;
                //object.animatedSprite.play()
                //object.animatedSprite.loop = true;

                // object.particle.plugin.wrap = {
                //     min: { x: this.engine.render.bounds.min.x, y: this.engine.render.bounds.min.y },
                //     max: { x: this.engine.render.bounds.max.x, y: this.engine.render.bounds.max.y }
                //   };
            });

            if (this.engine != null) Matter.Engine.update(this.engine);

            if (this.render != null) Matter.Render.world(this.render);
        }

        this.TitleSpriteTransition?.Update();
        //this.app?.ticker?.update();
    }
}